export default "__VITE_ASSET__BFT0UUAL__"